import axiosInstance from '@/store/axios'
import {rejectError } from '../helper';

export default {
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    items ({ commit }, params) {
      return axiosInstance.get('/api/v1/items', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    itemsPictures ({ commit }, params) {
      return axiosInstance.get('/api/v1/items/pictures', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    getItemById ({ commit, state }, params) {
      // eslint-disable-next-line consistent-return
      return axiosInstance.get(`/api/v1/items/${params.id}/info`, { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    itemCount ({ commit }, params) {
      return axiosInstance.get('/api/v1/items/$count', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    getItemAssets ({ commit }, params) {
      return axiosInstance.get('/api/v1/items/assets', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    updateItem ({ dispatch }, item) {
      return axiosInstance({
        method: 'PATCH',
        url: `/api/v1/items/${item.id}`,
        data: item,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    deleteItem ({ commit }, item) {
      return axiosInstance({
        method: 'DELETE',
        url: `/api/v1/items/${item.id}`,
      })
        .then((result) => result.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    stat ({ dispatch }) {
      return axiosInstance({
        method: 'GET',
        url: '/api/v1/items/stat',
      })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    getAssetReport ({ commit }, params) {
      return axiosInstance.get('/api/v1/asset-report', { params: params, responseType: 'blob' })
        .then((result) => result)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    getPackageReport ({ commit }, params) {
      return axiosInstance.get('/api/v1/package-report', { params: params, responseType: 'blob' })
        .then((result) => result)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    excludeItems ({ dispatch }, selected) {
      return axiosInstance.post('/api/v1/items/commands/bulk-remove', selected)
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    reimportItems ({ dispatch }, data) {
      if (!data.selected) data.selected = []
      return axiosInstance.post('/api/v1/instances/' + data.instanceId + '/commands/re-import', data.selected)
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    patchItem ({ dispatch }, item) {
      return axiosInstance({
        method: 'POST',
        url: '/api/v1/items/commands/edit-item',
        data: item,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    createSeries ({ dispatch }, item) {
      return axiosInstance({
        method: 'POST',
        url: '/api/v1/items/commands/add-series',
        data: item,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
  },
}
